import React, { useEffect } from 'react';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Button, { ButtonVariations } from '../SolvPatternLibrary/Button';
import BellIcon from '../SolvPatternLibrary/Icons/Bell';
import { fontFamily, fontSize } from '../../constants/text';
import { colors } from '../../constants/colors';
import { analyticsTrackEvent } from '../../core/analytics';
import {
  NATIVE_PUSH_FULL_SCREEN_DENY,
  NATIVE_PUSH_FULL_SCREEN_ALLOW,
  NATIVE_PUSH_FULL_SCREEN_OPEN_MODAL,
} from '../../core/analytics/events';
import { showModal } from '~/actions/runtime';

export const FULL_SCREEN_PUSH_PROMPT_MODAL = 'native push full screen modal';

const SmoothDialog = styled(Dialog)`
  -webkit-font-smoothing: antialiased;
`;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 25px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Icon = styled(BellIcon)`
  width: 100px;
  height: 100px;
`;

const Title = styled.h3`
  margin: 30px 0;
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.extraLarge};
  text-align: center;
  max-width: 80%;
`;

const Disclaimer = styled.p`
  color: ${colors.mrGray};
  max-width: 80%;
  text-align: center;
`;

const PrimaryCTA = styled(Button)`
  margin-top: 40px;
  width: 200px;
`;

const SecondaryCTA = styled(Button)`
  margin-top: 20px;
`;

const onAllow = (onClose: any) => () => {
  analyticsTrackEvent(NATIVE_PUSH_FULL_SCREEN_ALLOW);
  if (window.handleAcceptIosPushNative) {
    // Try using the function that triggers the native prompt directly
    // If it's not available (older versions of the app),
    // trigger the flow which includes also a custom alert before the native one
    window.handleAcceptIosPushNative();
  } else if (window.handleAcceptIosPushPermission) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'handleAcceptIosPushPermission' does not ... Remove this comment to see the full error message
    window.handleAcceptIosPushPermission();
  }
  onClose();
};

const onDeny = (onClose: any) => () => {
  analyticsTrackEvent(NATIVE_PUSH_FULL_SCREEN_DENY);
  onClose();
};

type FullScreenPromptProps = {
  onClose: (...args: any[]) => any;
  open: boolean;
};

export const FullScreenPrompt = withMobileDialog<FullScreenPromptProps>()(
  ({ onClose, open }: FullScreenPromptProps) => {
    useEffect(() => {
      if (open) {
        analyticsTrackEvent(NATIVE_PUSH_FULL_SCREEN_OPEN_MODAL);
      }
    }, [open]);

    return (
      <SmoothDialog
        fullScreen
        fullWidth
        onClose={onClose}
        open={open}
        PaperProps={{ classes: { root: 'dialog-root' } }}
      >
        <Root>
          <Icon />

          <Title>Get important health updates</Title>

          <Disclaimer>
            Solv uses push notifications to keep you up-to-date on your bookings, health reminders
            and insurance progress
          </Disclaimer>

          <ButtonsContainer>
            <PrimaryCTA onClick={onAllow(onClose)} variation={ButtonVariations.pinkPrimary}>
              Allow notifications
            </PrimaryCTA>

            <SecondaryCTA onClick={onDeny(onClose)} variation={ButtonVariations.link}>
              Not now
            </SecondaryCTA>
          </ButtonsContainer>
        </Root>
      </SmoothDialog>
    );
  }
);

export const showFullScreenPrompt = () => showModal(FULL_SCREEN_PUSH_PROMPT_MODAL);
